import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Link } from 'react-router-dom';
//import Button from '@mui/material/Button';

export const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  /* button {
    align-self: center;
    padding: 0 16px;
  } */
`;

export const Line = styled.div`
  ${({ isActive }) =>
    isActive
      ? css`
          background-color: ${() => Palette.Primary._500};
          height: 4px;
        `
      : css`
          height: 4px;
        `}
  transition: all 0.2s linear;
`;

export const Content = styled.div`
  margin-bottom: 76px;
`;

export const InnerContent = styled.div`
  display: flex;
  background: ${() => Palette.PrimaryGray._100};
  border-bottom: 1px solid ${() => Palette.PrimaryGray._200};
  z-index: 1100;
  align-items: center;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  padding: 0 32px;

  img {
    height: 32px;
    width: auto;
  }
`;

export const Nav = styled.nav`
  display: flex;
  margin-left: 50px;
  min-height: 77px;
`;

export const CustomLink = styled(Link)`
  color: ${() => Palette.PrimaryGray._900};
  display: block;
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 16px;

  :hover {
    border-radius: 4px;
    background-color: ${() => Palette.PrimaryGray._200};
  }
  transition: all 0.2s linear;
`;

export const EmailWrap = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const DropDown = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
